export default __webpack_public_path__ + "static/media/train-petta.5bd8e96d.svg";